<template>
    <div class="poi-edit-prices">
        <el-dialog 
            :visible.sync="dialogVisible" 
            :modal="mobile ? true : false" 
            :append-to-body="true" 
            :show-close="false" 
            :close-on-click-modal="false"
            :top="dialogTopMargin" 
            custom-class="poi-edit-prices__dialog"
        >
            <div class="poi-edit-prices__dialog__head">
                <span class="caption-light">{{ title }}</span>
                <div class="poi-edit-prices__dialog__close" @click="closeClickHandler">
                    <icon><IconClose/></icon>
                </div>
            </div>
            <div class="poi-edit-prices__dialog__body">
                <div class="poi-edit-prices__list" v-if="!addGasType">
                    <div class="poi-edit-prices__list__block" v-for="(gas, ind) in defaultGasList" :key="ind">
                        <div class="poi-edit-prices__list__block__item">
                            <div class="copy-medium black">{{ gas.label }}</div>
                            <div class="copy black">€ {{ gas.price }}</div>
                        </div>
                        <div class="poi-edit-prices__list__block__item">
                            <div class="copy black">Neuer Preis</div>
                            <div class="form__field-row">
                                <SmrInput
                                    value="20"
                                    placeholder="€ 0,000"
                                    inputType="number">
                                </SmrInput>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="poi-edit-prices__list__block" v-for="(gasType, index) in gasTypes" :key="index">
                            <div class="poi-edit-prices__list__block__item">
                                <div class="copy-medium black">{{ gasType.label }}</div>
                                <div class="smr-panel__actions__item smr-panel__actions__close" @click="removeGasClickHandler(index, gasType)">
                                    <icon :width="20" :height="20"><IconClose/></icon>
                                </div>
                            </div>
                            <div class="poi-edit-prices__list__block__item">
                                <div class="copy black">Neuer Preis</div>
                                <div class="form__field-row">
                                    <SmrInput
                                        :value="'20'"
                                        placeholder="€ 0,000"
                                    > 
                                    </SmrInput>
                                </div>
                            </div>
                         </div>
                    </div>

                    <div class="poi-edit-prices__list__block">
                        <div class="form__add-item poi-edit-prices__list__block__select" @click="addGasClickHandler">
                            <span class="form__add-item__text">Kraftstoffsorte hinzufügen</span>
                            <Icon class="form__add-item__icon">
                                <IconPlusCircle />
                            </Icon>
                        </div>
                    </div>

                    <SmrButton class="poi-edit-prices__button" @click.native="saveClickHandler">Bestätigen</SmrButton>
                </div>

                <SmrChoiceGroup 
                    class="poi-edit-prices__options"
                    v-if="addGasType"
                    :values="preselectedGas" 
                    :options="listOptions"
                    :output-array="true"
                    :single-choice="true"
                    :showAsList="true"
                    @change="fieldChangeHandler($event, preselectedGas)"
                />
                <div class="poi-edit-prices__options__button-wrapper" v-if="addGasType">
                    <SmrButton class="poi-edit-prices__button poi-edit-prices__button--group" @click.native="selectGasClickHandler">Hinzufügen</SmrButton>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { getPoiConfig } from '@/utils/poi-data/poi-config'
    import Icon from '@/components/Icon.vue'
    import IconClose from '@/components/icons/IconClose.vue'
    import IconPlusCircle from '@/components/icons/IconPlusCircle.vue'
    import SmrInput from '@/components/form/SmrInput.vue'
    import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'
    import SmrButton from '@/components/SmrButton.vue'
    import eventBus from '@/utils/event-bus'

    export default {
        components: {
            Icon,
            IconClose,
            IconPlusCircle,
            SmrInput,
            SmrChoiceGroup,
            SmrButton
        },

        data() {
            return {
                data: {},
                dialogVisible: false,
                addGasType: false,
                gasTypes: [],
                defaultGasList: [],
                selectedGas: [],
                listOptions: getPoiConfig('gasStations').types,
            }
        },
        computed: {
            ...mapGetters(['mobile']),
            dialogTopMargin() {
                return this.mobile ? '140px' : '298px';
            },
            title() {
                if(this.addGasType)  return 'Kraftstoffsorte hinzufügen';
                    return 'Preis melden'
            },
            preselectedGas() {
                return this.listOptions[0].value;
            }
        },
        mounted() {
            this.addListeners();
        },
        beforeDestroy() {
            this.removeListeners()
        },
        methods: {
            closeClickHandler() {
                if(this.addGasType) this.addGasType = false;
                else this.dialogVisible = false;
            },
            fieldChangeHandler(event) {
                this.selectedGas = this.listOptions.find(el => el.value === event);
            },
            selectGasClickHandler() {
                if(this.selectedGas.length === 0) this.selectedGas =  this.listOptions[0];
                this.gasTypes.push(this.selectedGas);
                let filterGasTypes = this.listOptions.filter(item => item !== this.selectedGas);
                this.selectedGas = [];
                this.listOptions = filterGasTypes;
                this.addGasType = false;
            },
            removeGasClickHandler(id, gas) {
                this.gasTypes.splice(id, 1);
                this.listOptions.push(gas);
            },
            addGasClickHandler() {
                this.addGasType = true;
            },
            showPOIEditPricesHandler(data) {
                this.dialogVisible = true;
                if(data) {
                   let otherItems = data.otherItems;
                   if(otherItems[0].label === 'Andere Quellen') otherItems.shift()
                   this.defaultGasList = otherItems;
                    // @TODO remove existing gas from the list
                }
            },
            addListeners() {
                eventBus.$on('showPriceChangeEvent', this.showPOIEditPricesHandler);
            },
            removeListeners() {
                eventBus.$off('showPriceChangeEvent', this.showPOIEditPricesHandler);
            },

            saveClickHandler() {
                this.dialogVisible = false;
                eventBus.$emit('thankYouMessage');
            }
        }
    }
</script>

<style lang="scss">
    .poi-edit-prices {
        $block: &;

        &__dialog {
            width: calc(100% - 32px);
            border-radius: $standard-border-radius;

            @include mq(tablet) {
                position: absolute;
                left: 403px;
                max-width: 350px !important;
            }
            
            @include mq(tablet-landscape) {
                left: 366px;
            }

           .el-dialog {
                &__wrapper {
                    background: transparent;
                }

                &__header {
                    display: none;
                }

                &__body {
                    padding: 0;
                    word-break: initial;
                    font-size: 15px;
                }
            }

            &__head {
                padding: 8px 16px;
                border-bottom: 1px solid $color-black-005;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            &__close {
                display: flex;
                color: $color-black-02;
                transition: 0.2s;
                cursor: pointer;
            } 
        }

        &__list {

            max-height: 440px;
            overflow-y: auto;

            padding: 0 16px;

            @include mq($until: tablet) {
                padding-bottom: 16px;
            }
            
            &__block {
                display: flex;
                flex-direction: column;
                border-bottom: 1px solid $color-black-005;
                padding: 16px 0;

                &__select {
                    width: 100% !important;
                }

                &__item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    &:not(:last-of-type) {
                        margin-bottom: 12px;
                    }

                    .el-input input {
                        padding: 0 8px;
                        max-width: 68px;
                    }
                }

                &__select {
                    width: 100%;
                    margin-top: 0;
                }
            }
        }

        &__options {
            padding: 0 16px;
            max-height: 340px;
            overflow-y: auto;

            &__button-wrapper {
                padding: 16px;
            }
        }

        &__button {

             @include mq(tablet) {
                margin-bottom: 16px;
            }

            &--group {
                margin-bottom: 0;
            }
        }
    }
</style>
